import * as React from 'react';
import {FC, useEffect, useState} from 'react';
import {observer} from 'mobx-react-lite';

import Background from '../../assets/images/create_project_bg.png';
import {IntegrationInstructions} from '../../components/IntegrationInstructions';
import {LogEditForm} from '../../components/LogEditForm';
import {LogEditState} from './LogEditState';
import {LogType} from '../../swagger';
import {useParams} from 'react-router-dom';

export const LogEditView: FC = observer(() => {
    const {projectId, logId} = useParams();

    const [state] = useState(() => new LogEditState());

    useEffect(() => {
        if (logId) {
            state.loadLogItem(logId);
        }

        if (projectId) {
            state.initNew(projectId);
        }
    }, [logId]);

    return (
        <section
            style={{
                backgroundImage: `url(${Background})`,
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                height: '100%',
            }}
        >
            <h1 className="font-bold font-roboto-bold mb-4 text-3xl">{state.projectName}</h1>
            <LogEditForm state={state}/>
            {state.item.logId && state.item.logType !== LogType.UptimeCheck && (
                <IntegrationInstructions
                    title={'Integration instructions'}
                    logType={state.item.logType!}
                    logId={state.item.logId}
                />
            )}
        </section>
    );
});
